// extracted by mini-css-extract-plugin
export var container = "breadcrumb-module--container--47da3";
export var item = "breadcrumb-module--item--224d6";
export var separator = "breadcrumb-module--separator--ca231";